import { render, staticRenderFns } from "./ProjectsListSettingsDialog.vue?vue&type=template&id=7344a80d"
import script from "./ProjectsListSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ProjectsListSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports